import React, { Component } from 'react';
import { connect } from 'react-redux';
import { handleSearch } from '../modules/search_query';
import { handleSuggest } from '../modules/search_suggestions';

class SearchBox extends Component {

  constructor(props) {
    super(props);
    this.state ={
      query: '',
    }
    this.handleSearch        = this.handleSearch.bind(this);
    this.handleSuggest       = this.handleSuggest.bind(this);
    this.handleKeyDown       = this.handleKeyDown.bind(this);
    this.handleSuggestSearch = this.handleSuggestSearch.bind(this);
  }

  handleSuggest( sLabel, event ) {
    let sValue      = event.target.value;
    let oStaleState = this.state;
    this.setState({ query: sValue });
    this.props.dispatch( handleSuggest( sValue ) );
  }

  handleSearch(event) {
    event.preventDefault();
    this.props.dispatch( handleSearch( this.state.query ));
    this.state ={ query: '' }
  }

  handleSuggestSearch(sQuery) {
    this.props.dispatch( handleSearch( sQuery ));
    this.state ={ query: '' }
  }

  // Make enter key run search
  handleKeyDown( event ) {
    if (event.keyCode === 13) {
      this.handleSearch( event );
    }
  }

  render() {
    let sValue             = this.state.query;
    let sLabel             = this.props.label;
    let aSuggestions       = this.props.searchSuggestions || [];
    let sSuggestionsActive = '' ;

    if(this.props.searchSuggestions){
      sSuggestionsActive = (!this.state.query == '' && aSuggestions.length > 0) ? 'active' : '' ;
      aSuggestions = this.props.searchSuggestions.map((sSuggestion, i) => {
        if (sSuggestion) {
          return (
            <li key = {i} >
              <a onClick={this.handleSuggestSearch.bind(this, sSuggestion)} >
                {sSuggestion}
              </a>
            </li>
          );
        }
      });
    }

    return (
      <div className="search-box">
        <form onSubmit={this.handleSearch.bind(this)}>
          <button >
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
               width="18px" height="18px" viewBox="0 0 18 18" enable-background="new 0 0 18 18">
              <path
              fill="#d0dadc"
              d="M17.208,15.357l-5.332-5.04c-0.049-0.049-0.109-0.073-0.164-0.109c0.724-1.01,1.154-2.242,1.154-3.576
              c0-3.398-2.765-6.162-6.162-6.162S0.543,3.234,0.543,6.632c0,3.397,2.764,6.161,6.161,6.161c1.37,0,2.632-0.455,3.656-1.213
              c0.034,0.049,0.055,0.104,0.098,0.147l5.332,5.04c0.195,0.196,0.452,0.295,0.709,0.295c0.255,0,0.51-0.097,0.705-0.291
              C17.596,16.382,17.598,15.749,17.208,15.357z M6.705,10.793c-2.294,0-4.161-1.867-4.161-4.161c0-2.295,1.867-4.162,4.161-4.162
              c2.295,0,4.162,1.867,4.162,4.162C10.867,8.926,9,10.793,6.705,10.793z"
              />
            </svg>
          </button>
          <input
            type        = "text"
            value       = {this.state.query}
            placeholder = "Search"
            onChange    = {this.handleSuggest.bind( this, sLabel )}
            onKeyDown   = {this.handleKeyDown}
          />
        </form>
        <ul className={"search-suggestions list " + sSuggestionsActive }>
          {aSuggestions}
        </ul>
      </div>
    );
  }
};



function mapStateToProps(state){
    return {
      'searchSuggestions': state.searchSuggestions
    };
}

export default connect(mapStateToProps)(SearchBox);



// WEBPACK FOOTER //
// ./src/components/SearchBox.jsx